export enum Routes {
  Upgrade = 'user/plan',
  // OfferingsPatch is used for the new "OES Source Of Truth" upgrades
  OfferingsPatch = 'accounts/offerings',
  // Cancel is used to change subscription to terminal plans (end-of-trial)
  // which are not self serve.
  OfferingsCancel = 'accounts/offerings/cancel',
  Accounts = 'accounts',
}
